'use strict';
var processInclude = require('base/util');

$(document).ready(function () {
    try {
        require('./checkout/placesAutocomplete').init();
    } catch (e) {}

    try {
        processInclude(require('./checkout/customCheckout'));
    } catch (e) {}
});
require('./otpfunctions');
require('./checkout/paymentMethod');
require('gyftr/gyftr');
require('payglocal/payGlocal');
require('./checkout/coupon');
